import selector from './common/selector';

export const getCustomerCoursesSelector = selector([state => state.customer.customerCourses]);
export const getCustomerMembershipsSelector = selector([state => state.customer.customerMemberships]);
